import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createRevision,
  deleteRevision,
  getRevision,
  getRevisions,
  getRevisionsMasterData,
  updateRevision
} from '../../../api/revisions';

export const getRevisionsAsync = createAsyncThunk(
  'revisions/getRevisions',
  getRevisions
);

export const getRevisionsMasterDataAsync = createAsyncThunk(
  'revisions/getRevisionsMasterData',
  getRevisionsMasterData
);

export const getRevisionAsync = createAsyncThunk(
  'revisions/getRevision',
  getRevision
);

export const createRevisionAsync = createAsyncThunk(
  'revisions/createRevision',
  createRevision
);

export const updateRevisionAsync = createAsyncThunk(
  'revisions/updateRevision',
  updateRevision
);

export const deleteRevisionAsync = createAsyncThunk(
  'revisions/deleteRevision',
  deleteRevision
);

export interface Revision {
  id: number;
  name: string;
}

interface RevisionState {
  data: Revision[];
  masterData: Revision[];
  count: number;
  selectedRevision: Revision | null;
}

const initialState: RevisionState = {
  data: [],
  masterData: [],
  count: 0,
  selectedRevision: null
};

export default createSlice({
  name: 'revisions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRevisionsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(getRevisionsMasterDataAsync.fulfilled, (state, action) => {
      state.masterData = action.payload.data;
      state.count = action.payload.count;
    });
    builder.addCase(getRevisionAsync.fulfilled, (state, action) => {
      state.selectedRevision = action.payload;
    });
  }
});
